// extracted by mini-css-extract-plugin
export var avatar = "_hr-3";
export var avatarContainer = "_hr-2";
export var avatarSpacer = "_hr-5";
export var avatarSpacerContainer = "_hr-4";
export var avatarStackContainer = "_hr-1";
export var bubble = "_hr-0";
export var remainderBubble = "_hr-6";